import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { IMenuItem } from 'src/app/shared/services/navigation.service';
import { NavigationService } from '../../../shared/services/navigation.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  animations: [
    trigger('contentExpansion', [
      state(
        'expanded',
        style({ height: '*', opacity: 1, visibility: 'visible' })
      ),
      state(
        'collapsed',
        style({ height: '0px', opacity: 0, visibility: 'hidden' })
      ),
      transition(
        'expanded <=> collapsed',
        animate('200ms cubic-bezier(.37,1.04,.68,.98)')
      ),
    ]),
  ],
})
export class SidebarComponent implements OnInit {
  nav!: IMenuItem[];
  selectedItem!: IMenuItem | null;
  today = new Date();
  @Output() pricingPackages = new EventEmitter()
  isHaveSubscribedPlan!: boolean;
  subscriptionEndDays!: boolean;
  @Input() logo = '';

  constructor(
    public navService: NavigationService,
    public router: Router,
    private auth: AuthenticationService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    // Existing code
    this.navService.menuItems.subscribe(items => {
      this.nav = items;

      //  IMPORTANT: update active menu AFTER nav is ready
      this.updateActiveMenu();
    });

    const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
    this.isHaveSubscribedPlan = !!authUser.HaveSubscribedPlan;
    this.subscriptionEndDays = !!authUser.SubscriptionEndDays;

    // Listen to route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateActiveMenu());
  }

  /** Update active state based on current route */
  updateActiveMenu(): void {
    const currentUrl = this.router.url;

    this.nav.forEach(item => {

      // reset first
      item.active = false;

      // 🔹 Normal link
      if (item.type === 'link') {
        if (item.state && currentUrl.includes(item.state)) {
          item.active = true;
        }
      }

      // 🔹 Dropdown
      if (item.type === 'dropDown' && item.sub?.length) {

        const hasActiveChild = item.sub.some(sub =>
          sub.state ? currentUrl.includes(sub.state) : false
        );

        item.active = hasActiveChild;   // 🔥 THIS activates dropdown
      }
    });
  }

  isActiveMenu(link: any) {
    return location.href.includes(link);
  }

  /** Handle dropdown toggle */
  selectItem(item: IMenuItem): void {
    if (item.type === 'dropDown') {
      item.active = !item.active;
    }
  }

  setActiveMainItem(item: any) {
    this.nav.forEach((element) => {
      element.active = false;
    });
    item.active = true;
  }

  toggelSidebar() {
    const navState = this.navService.sidebarState;
    navState.sidenavOpen = !navState.sidenavOpen;
  }

  openPricingPackages() {
    this.pricingPackages.emit(true)
  }

  hasPermission(permission: string) {
    return this.auth.hasPermission(permission);
  }
}
